package team.platforma.multiplatform_material_extension.fab

import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.tween
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonColors
import androidx.compose.material3.ButtonElevation
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.min
import team.platforma.multiplatform_material_extension.correction
import team.platforma.multiplatform_material_extension.fab.style.AppFabStyle
//import team.platforma.multiplatform_material_extension.keyboard.rememberKeyboardHeight
import team.platforma.multiplatform_material_extension.ui.buttons.ExpandStrategy
import team.platforma.multiplatform_material_extension.ui.buttons.IconGravity

@Composable
fun AppFab(
    expand: Boolean = false,
    modifier: Modifier = Modifier,
    expandStrategy: ExpandStrategy = ExpandStrategy.WrapContent,
    iconGravity: IconGravity = IconGravity.End,
    text: @Composable (() -> Unit)? = null,
    icon: @Composable (() -> Unit),
    enabled: Boolean = true,
    hide: Boolean = true,
    shape: Shape = AppFabStyle.fabButton().shape,
    colors: ButtonColors = AppFabStyle.fabButton().colors,
    onClick: () -> Unit,
    elevation: ButtonElevation = AppFabStyle.fabButton().elevation,
    expandDuration: Int? = null,
    shrinkDuration: Int? = null,
    border: BorderStroke? = AppFabStyle.fabButton().border

) {
    var mExpand by remember { mutableStateOf(false) }
    var mEnabled by remember { mutableStateOf(true) }
    var mHide by remember { mutableStateOf(true) }

    val density = LocalDensity.current

    LaunchedEffect(expand) {
        mExpand = expand
    }

    LaunchedEffect(enabled) {
        mEnabled = enabled
    }

    LaunchedEffect(hide) {
        mHide = hide
    }

//    val keyboardHeight by rememberKeyboardHeight()

    var maxWidth by remember { mutableStateOf(0f) }

    val width by animateDpAsState(
        targetValue = if (mExpand) {
            if (text != null) {
                with(density) { maxWidth.toDp() }
            } else {
                56.dp
            }
        } else {
            56.dp
        },
        animationSpec = if (mExpand) {
            when (expandStrategy) {
                ExpandStrategy.MaxWidth -> tween(durationMillis = expandDuration ?: 200)
                ExpandStrategy.WrapContent -> tween(durationMillis = expandDuration ?: 60)
            }

        } else {
            tween(durationMillis = shrinkDuration ?: 120)
        }
    )

    val alpha by animateFloatAsState(
        targetValue = if (mExpand) 1f else 0f,
        animationSpec = if (mExpand) tween(durationMillis = 120) else tween(durationMillis = 60)
    )


//    initButtonKeyGrabber(keyGrabber, onClickKey){
//        if (mEnabled) {
//            onClick()
//        }
//    }

    if (expandStrategy == ExpandStrategy.MaxWidth) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .onGloballyPositioned { coordinates ->
                    if (text != null) {
                        maxWidth = coordinates.size.width.toFloat()
                    }

                }
        )
    }

    val animatedHeight by animateDpAsState(
        targetValue = if (mHide) 0.dp else 56.dp
    )
    val animatedWidth by animateDpAsState(
        targetValue = if (mHide) 0.dp else width
    )

    Box(
        modifier = modifier.then(
            Modifier.heightIn(min = 56.dp).widthIn(min = 56.dp)
        ),
        contentAlignment = Alignment.Center
    ) {
        Button(
            modifier = Modifier.width(animatedWidth).heightIn(min = animatedHeight, max = animatedHeight),
            onClick = { onClick() },
            contentPadding = PaddingValues(0.dp),
            enabled = mEnabled,
            elevation = elevation,
            shape = shape,
            colors = colors,
            border = border
        ) {
            Box(
                modifier = Modifier,
                contentAlignment = when (iconGravity) {
                    IconGravity.End -> Alignment.CenterEnd
                    IconGravity.Start -> Alignment.CenterStart
                }
            ) {
                Column(
                    Modifier.fillMaxWidth(),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    if (text != null) {
                        Box(
                            modifier = Modifier
                                .onGloballyPositioned
                                { layoutCoordinates ->
                                    if (expandStrategy == ExpandStrategy.WrapContent) {
                                        maxWidth =
                                            layoutCoordinates.size.width.toFloat() + correction(56.dp)
                                    }

                                }.alpha(alpha)
                                .padding(
                                    start = when (expandStrategy) {
                                        ExpandStrategy.WrapContent -> {
                                            when (iconGravity) {
                                                IconGravity.Start -> 24.dp
                                                IconGravity.End -> 0.dp
                                            }
                                        }

                                        ExpandStrategy.MaxWidth -> {
                                            0.dp
                                        }
                                    },
                                    end = when (expandStrategy) {
                                        ExpandStrategy.WrapContent -> {
                                            when (iconGravity) {
                                                IconGravity.Start -> 0.dp
                                                IconGravity.End -> 24.dp
                                            }
                                        }

                                        ExpandStrategy.MaxWidth -> {
                                            0.dp
                                        }
                                    }
                                )
                        ) {
                            text()
                        }

                    }

                }


                Box(
                    modifier = when (iconGravity) {
                        IconGravity.End -> Modifier.size(48.dp).padding(end = 8.dp)
                        IconGravity.Start -> Modifier.size(48.dp).padding(start = 8.dp)
                    },
                    contentAlignment = Alignment.Center
                ) {
                    icon()
                }
            }
        }
    }
}